// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sk-0";